import { Outlet } from 'react-router'
import { StudioAppShell } from './shell/StudioAppShell'

function DashboardLayout() {
  return (
    <StudioAppShell>
      <Outlet />
    </StudioAppShell>
  )
}

export default DashboardLayout
